import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTableModule } from '@angular/material/table';
import { UIRouterModule } from '@uirouter/angular';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';
import { AuthModule } from '../auth/auth.module';

import { FormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CodeInputModule } from 'angular-code-input';
import { RvBadgeComponent } from '../components/rv-badge/rv-badge.component';
import { FolderPathComponent } from '../components/folders/folder-path/folder-path.component';
import { SearchFilterComponent } from '../components/search-filter/search-filter.component';
import { ModeratorJoinBulkActionsBarComponent } from './components/moderator-join/moderator-join-bulk-actions-bar/moderator-join-bulk-actions-bar.component';
import { ModeratorJoinInstructionsCardComponent } from './components/moderator-join/moderator-join-instructions-card/moderator-join-instructions-card.component';
import { ModeratorJoinComponent } from './components/moderator-join/moderator-join.component';
import { ModeratorRoomComponent } from './components/moderator-room/moderator-room.component';
import { ScreenSharingControlsComponent } from './components/screen-sharing-controls/screen-sharing-controls.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { ScreenSharingComponent } from './components/screen-sharing/screen-sharing.component';
import { routes } from './screen-sharing.routes';
import { ViewportComponent } from './viewport/viewport.component';
import { FocusOutlineDirective } from '../accessibility/directives/focus-outline/focus-outline.directive';

@NgModule({
  declarations: [
    ModeratorJoinComponent,
    ModeratorRoomComponent,
    ScreenSharingComponent,
    ScreenSharingControlsComponent,
    ViewportComponent,
  ],
  imports: [
    UIRouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    ComponentsModule,
    SharedModule,
    AuthModule,
    PopoverModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatSliderModule,
    MatDividerModule,
    MatFormFieldModule,
    MatTabsModule,
    MatTooltipModule,
    MatSelectModule,
    CodeInputModule,
    NotificationAlertComponent,
    FolderPathComponent,
    ModeratorJoinBulkActionsBarComponent,
    ModeratorJoinInstructionsCardComponent,
    SearchFilterComponent,
    RvBadgeComponent,
    FocusOutlineDirective,
  ],
})
export class ScreenSharingModule {}
